import React, { Fragment, Component } from "react";
import { Link } from "react-router-dom";
import map from "lodash.map";
import filter from "lodash.filter";
import { RouteUrls } from "../../../configs/routeUrls";
import { Loader } from "../../Loader";
import { Button } from "../../Button";
import { SystemDistrict } from "../../../utils/enums";
import { dayFormat } from "../../../utils/date";
import { ChartBarWrapper } from "../../ChartWrapper";
import { ProjectResult } from "./BudgetProjectResult";
import { ProjectResultByCategory } from "./BudgetProjectResultByCategory";

export const BudgetResultCard = ({
  isBudgetResultLoading,
  projectBudgetYearValue: budgetYearValue = 0,
  projectDescription: description = "",
  projectDateFrom: dateFrom = null,
  projectDateTo: dateTo = null,
  projectModeName: modeName = "",
  isOnlyOneOffice = true,
  projectOnlyForLegalAge: onlyForLegalAge = false,
  projectOfficeName: officeName = "",
  projectTitle: title = "",
  budgetVoteShowResultsByDistrict = false,
  budgetVoteShowResultsBySex = false,
  resultsByAreaAndCategory = false,
  ...props
}) => (
  <Fragment>
    {isBudgetResultLoading && <Loader loading={isBudgetResultLoading} />}
    {!isBudgetResultLoading && (
      <Fragment>
        <div id="content" className="container districts margin-top-40">
          <div className="consultations__item">
            <div className="consultations__header">
              <div className="consultations__title">{title}</div>

              <div className="consultations__icons">
                <Link
                  to={RouteUrls.Budget.pages.prerequisiteFunc(budgetYearValue)}
                  title="Do pobrania"
                >
                  <i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-download" />
                </Link>
                <Link
                  to={RouteUrls.Budget.pages.scheduleFunc(budgetYearValue)}
                  title="Harmonogram"
                >
                  <i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-calendar-alt" />
                </Link>
                <Link
                  to={RouteUrls.Budget.pages.helpFunc(budgetYearValue)}
                  title="Pomoc"
                >
                  <i
                    className={`link link__icon link__icon-biggest link--primary-dark fas fa-question-circle`}
                  />
                </Link>
              </div>
            </div>
            <div className="consultations__body">
              <div className="consultation-item consultation-item-no-shadow consultation-item-no-border">
                <div className="consultation-item__body">
                  <div className="consultation-item__desc margin-right-20">
                    <div className="consultation-description__text">
                      {description}
                    </div>
                  </div>
                  <div>
                    <div className="consultation-item__infos">
                      <div className="consultation-item__info">
                        <div className="consultation-item__info-label">
                          Czas trwania od:{" "}
                        </div>
                        <div className="consultation-item__info-value">{`${dayFormat(
                          dateFrom
                        )}`}</div>
                        <div className="consultation-item__info-label">
                          {" "}
                          do:{" "}
                        </div>
                        <div className="consultation-item__info-value">{`${dayFormat(
                          dateTo
                        )}`}</div>
                      </div>
                      <div className="consultation-item__info">
                        <div className="consultation-item__info-label">
                          Tryb:
                        </div>
                        <div className="consultation-item__info-value">
                          {modeName}
                        </div>
                      </div>
                      <div className="consultation-item__info">
                        <div className="consultation-item__info-label">
                          Tylko dla pełnoletnich:
                        </div>
                        <div className="consultation-item__info-value">
                          {onlyForLegalAge ? "Tak" : "Nie"}
                        </div>
                      </div>
                      {!isOnlyOneOffice && (
                        <div className="consultation-item__info">
                          <div className="consultation-item__info-label">
                            Jednostka:{" "}
                          </div>
                          <div className="consultation-item__info-value">
                            {officeName}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {map(props.districts, (district, districtIndex) => (
                <DistrictResult
                  {...props}
                  key={districtIndex}
                  categories={district.categories}
                  name={district.districtName}
                  resultsByAreaAndCategory={resultsByAreaAndCategory}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="container statistics">
          <div className="statistic">
            <div className="statistic__title">Podsumowanie głosowania</div>
            <div className="statistic__items">
              <div className="statistic__item">
                <div>{<i className="fas fa-users statistic__icon" />}</div>
                <div className="statistic__text">Liczba głosów oddanych</div>
                <div className="statistic__value">
                  {props.voteCount + props.incorrectVoteCount}
                </div>
              </div>
              <div className="statistic__item">
                <div>
                  {<i className="far fa-check-circle statistic__icon" />}
                </div>
                <div className="statistic__text">Liczba głosów ważnych</div>
                <div className="statistic__value">{props.voteCount}</div>
              </div>
              <div className="statistic__item">
                <div>
                  {<i className="far fa-times-circle statistic__icon" />}
                </div>
                <div className="statistic__text">Liczba głosów nieważnych</div>
                <div className="statistic__value">
                  {props.incorrectVoteCount}
                </div>
              </div>
            </div>
          </div>
          {budgetVoteShowResultsBySex && (
            <div className="statistic">
              <div className="statistic__title">
                Liczba głosów ważnych w podziale na płeć
              </div>
              <div className="statistic__items">
                <div className="statistic__item">
                  <div>
                    <i className="fas fa-female statistic__icon" />
                  </div>
                  <div className="statistic__value">
                    {props.femaleVoteCount}
                  </div>
                </div>
                <div className="statistic__item">
                  <div>
                    <i className="fas fa-male statistic__icon" />
                  </div>
                  <div className="statistic__value">{props.maleVoteCount}</div>
                </div>
              </div>
              <div className="statistic__text">
                Liczba głosów nieważnych - {props.incorrectVoteCount} (w tym:
                mężczyźni - {props.incorrectMaleVoteCount}, kobiety -{" "}
                {props.incorrectFemaleVoteCount})
              </div>
            </div>
          )}
          {budgetVoteShowResultsByDistrict && (
            <div className="statistic" style={{ marginBottom: 0 }}>
              <div className="statistic__title">
                Frekwencja w podziale na obszary
              </div>
              <div className="statistic__subtitle">
                (z wyłączeniem głosów nieważnych)
              </div>
              <div className="statistic__items">
                <div className="statistic__chart">
                  <Chart
                    summaries={map(
                      filter(
                        props.userVoteCountByDistrict,
                        (vote) =>
                          vote.districtName &&
                          vote.districtId !== SystemDistrict
                      ),
                      (vote) => ({
                        x: vote.districtName,
                        y: vote.voteCount,
                      })
                    )}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="buttons padding-top-20 padding-bottom-20">
            <Button variant="danger" onClick={props.onCancel}>
              Powrót
            </Button>
          </div>
        </div>
      </Fragment>
    )}
  </Fragment>
);

class DistrictResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: true,
    };

    this.toggleOpen = (e) => {
      e.preventDefault();
      this.setState({
        opened: !this.state.opened,
      });
    };
  }

  render() {
    const { name, categories, resultsByAreaAndCategory } = this.props;
    const { opened } = this.state;

    console.log(categories);

    return (
      <Fragment>
        <div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
          <div className="consultations__header">
            <div className="consultations__title consultations__title--center">
              {name}
            </div>

            <div className="consultations__icons">
              <div
                className="consultations__switch consultations__switch--primary-dark"
                onClick={this.toggleOpen}
              >
                {opened ? "Zwiń" : "Rozwiń"}
                {
                  <i
                    className={`consultations__icon fas fa-angle-${
                      opened ? "up" : "down"
                    }`}
                  />
                }
              </div>
            </div>
          </div>
          {opened && (
            <div className="consultations__body">
              {!resultsByAreaAndCategory
                ? map(categories, (project, projectIndex) => (
                    <ProjectResult
                      {...this.props}
                      index={projectIndex}
                      key={projectIndex}
                      {...project}
                    />
                  ))
                : map(categories, (project, projectIndex) => (
                    <ProjectResultByCategory
                      key={`project-${projectIndex}`}
                      index={projectIndex}
                      {...project}
                    />
                  ))}
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

const Chart = ({ ...props }) => <ChartBarWrapper summaries={props.summaries} />;

BudgetResultCard.defaultProps = {
  isBudgetResultLoading: false,
};
